import React from 'react';
import { useStoreActions } from 'easy-peasy';

import Sharing from '~/components/Sharing';

export default () => {
  const setInfoboxContent = useStoreActions(
    (state) => state.info.setInfoboxContent
  );

  return <Sharing setInfoboxContent={setInfoboxContent} />;
};
